import {
  Button,
  Field,
  Picker,
  ActionSheet,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Switch,
  CountDown,
  Dialog,
  Overlay,
  Checkbox,
  CheckboxGroup,
  NavBar,
  Icon,
  Popup,
  Popover,
  Toast,
  Loading,
  DatetimePicker,
  List,
  PullRefresh,
  Tag,
  Form,
  Step,
  Steps,
} from 'vant'

const components = [
  Button,
  Field,
  Picker,
  ActionSheet,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Switch,
  CountDown,
  Dialog,
  Overlay,
  Checkbox,
  CheckboxGroup,
  NavBar,
  Icon,
  Popup,
  Popover,
  Toast,
  Loading,
  DatetimePicker,
  Popup,
  List,
  PullRefresh,
  Tag,
  Form,
  Step,
  Steps,
]

export function requireVant(obj: any) {
  components.forEach(item => {
    obj.use(item)
  })
}
